import { BsCalendar4 } from "react-icons/bs";
import DropdownButton from "./DropdownButton";
import Calendar, { CalendarRef } from "../dashboard/Calendar";
import { useRef, useState } from "react";

interface CalendarButtonProps {
    onDateRangeChange?: (startDate: Date | null, endDate: Date | null) => void;
}

export default function CalendarButton({ onDateRangeChange }: CalendarButtonProps) {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const calendarRef = useRef<CalendarRef>(null);
    
    // Format the button text based on selected dates
    const getButtonText = () => {
        if (startDate && endDate) {
            // If start and end dates are the same, show just one date (single day selection)
            if (startDate.getTime() === endDate.getTime()) {
                return startDate.toLocaleDateString();
            }
            // Otherwise show the date range
            return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
        } else if (startDate) {
            return startDate.toLocaleDateString();
        } else {
            return "Select Date Range";
        }
    };
    
    // Handle date range changes from the Calendar component
    const handleDateRangeChange = (newStartDate: Date | null, newEndDate: Date | null) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
        
        // Notify parent component if callback is provided
        if (onDateRangeChange) {
            onDateRangeChange(newStartDate, newEndDate);
        }
    };
    
    return (
        <DropdownButton 
            icon={<BsCalendar4 size={"20px"} />} 
            text={getButtonText()} 
            dropdownContent={
                <Calendar 
                    ref={calendarRef}
                    initialStartDate={startDate || undefined}
                    initialEndDate={endDate || undefined}
                    onDateRangeChange={handleDateRangeChange}
                />
            } 
        />
    );
}
